interface Properties {
  width?: number;
  height?: number;
  color?: string;
  /** Inward arrows for the collapse action, outward for expand. */
  collapse?: boolean;
}

/**
 * Expand/collapse-view glyph. Replaces `assets/expand_icon.png`, which is a
 * white raster built for the panel's old purple chrome and can't be recoloured.
 */
const FigmaExpandViewIcon = ({
  width = 13,
  height = 13,
  color = '#5B6472',
  collapse = false,
}: Properties) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    {collapse ? (
      <>
        <path
          d='M9.5 6.5H13M9.5 6.5V3M9.5 6.5L14 2'
          stroke={color}
          strokeWidth='1.4'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M6.5 9.5H3M6.5 9.5V13M6.5 9.5L2 14'
          stroke={color}
          strokeWidth='1.4'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </>
    ) : (
      <>
        <path
          d='M10 2H14M14 2V6M14 2L9.5 6.5'
          stroke={color}
          strokeWidth='1.4'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M6 14H2M2 14V10M2 14L6.5 9.5'
          stroke={color}
          strokeWidth='1.4'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </>
    )}
  </svg>
);

export default FigmaExpandViewIcon;
